/* ==============================================
   IKM Header – Interactions
   Search toggle, mobile drawer, accordion submenus,
   sticky header behaviour
   ============================================== */

(function () {
  'use strict';

  /* ── DOM refs ── */
  var searchBar = document.querySelector('[data-search-bar]');
  var searchInput = searchBar ? searchBar.querySelector('.ikm-search__input') : null;
  var searchOpenBtns = document.querySelectorAll('[data-search-open]');
  var searchCloseBtn = document.querySelector('[data-search-close]');

  var drawer = document.querySelector('[data-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  var drawerOpenBtns = document.querySelectorAll('[data-drawer-open]');
  var drawerCloseBtn = document.querySelector('[data-drawer-close]');
  var drawerBackBtn = document.querySelector('[data-drawer-back]');

  var headerWrapper = document.querySelector('[data-header-wrapper]');

  /* ===========================
     SEARCH
     =========================== */
  function openSearch() {
    if (!searchBar) return;
    searchBar.hidden = false;
    if (searchInput) {
      searchInput.value = '';
      searchInput.focus();
    }
  }

  function closeSearch() {
    if (!searchBar) return;
    searchBar.hidden = true;
    if (searchInput) searchInput.value = '';
  }

  searchOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', openSearch);
  });

  if (searchCloseBtn) {
    searchCloseBtn.addEventListener('click', closeSearch);
  }

  /* Close search on Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (searchBar && !searchBar.hidden) closeSearch();
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    }
  });

  /* ===========================
     MOBILE DRAWER
     =========================== */
  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';

    /* Reset all open submenus */
    collapseAllSubmenus();
  }

  drawerOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });

  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ===========================
     ACCORDION SUBMENUS
     =========================== */
  function collapseAllSubmenus() {
    document.querySelectorAll('.ikm-drawer__submenu.is-open').forEach(function (sub) {
      sub.classList.remove('is-open');
    });
    document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    if (drawerBackBtn) drawerBackBtn.classList.remove('is-visible');
  }

  document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = this.getAttribute('data-submenu-toggle');
      var submenu = document.querySelector('[data-submenu="' + idx + '"]');
      var isOpen = this.getAttribute('aria-expanded') === 'true';

      /* Close other submenus first */
      document.querySelectorAll('[data-submenu-toggle]').forEach(function (otherBtn) {
        if (otherBtn !== btn) {
          otherBtn.setAttribute('aria-expanded', 'false');
          var otherIdx = otherBtn.getAttribute('data-submenu-toggle');
          var otherSub = document.querySelector('[data-submenu="' + otherIdx + '"]');
          if (otherSub) otherSub.classList.remove('is-open');
        }
      });

      if (isOpen) {
        this.setAttribute('aria-expanded', 'false');
        if (submenu) submenu.classList.remove('is-open');
        if (drawerBackBtn) drawerBackBtn.classList.remove('is-visible');
      } else {
        this.setAttribute('aria-expanded', 'true');
        if (submenu) submenu.classList.add('is-open');
        if (drawerBackBtn) drawerBackBtn.classList.add('is-visible');
      }
    });
  });

  /* Back button collapses expanded submenu */
  if (drawerBackBtn) {
    drawerBackBtn.addEventListener('click', collapseAllSubmenus);
  }

  /* ===========================
     STICKY HEADER
     =========================== */
  if (headerWrapper) {
    var stickyType = headerWrapper.getAttribute('data-sticky-type');

    if (stickyType === 'on-scroll-up') {
      var lastScrollY = 0;
      var ticking = false;

      function handleScroll() {
        var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll <= 0) {
          headerWrapper.classList.remove('ikm-header-wrapper--hidden');
        } else if (currentScroll > lastScrollY && currentScroll > 80) {
          /* Scrolling DOWN past header height */
          headerWrapper.classList.add('ikm-header-wrapper--hidden');
        } else {
          /* Scrolling UP */
          headerWrapper.classList.remove('ikm-header-wrapper--hidden');
        }

        lastScrollY = currentScroll;
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(handleScroll);
          ticking = true;
        }
      });
    }
  }
})();


/* ==============================================
   IKM Header – Cart Badge Live Update
   ============================================== */
(function () {
  'use strict';

  function updateCartBadge() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ikm-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(
          new CustomEvent('ikm:cart-updated', { detail: cart })
        );
      })
      .catch(function (err) {
        console.error('Cart badge update failed:', err);
      });
  }

  /* Intercept fetch calls that mutate the cart (covers most AJAX add-to-cart buttons/apps) */
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)\.js/.test(url);

    return originalFetch.apply(this, args).then(function (response) {
      if (isCartMutation && response.ok) {
        updateCartBadge();
      }
      return response;
    });
  };

  /* Fallback for plain (non-AJAX) form submissions to /cart/add */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.action && form.action.indexOf('/cart/add') !== -1) {
      setTimeout(updateCartBadge, 300);
    }
  });

  /* Keep in sync on initial page load too */
  document.addEventListener('DOMContentLoaded', updateCartBadge);
})();